import { render, staticRenderFns } from "./ProviderPurchasePopup.vue?vue&type=template&id=3897f666"
import script from "./ProviderPurchasePopup.vue?vue&type=script&lang=js"
export * from "./ProviderPurchasePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports